import React from 'react';

import cx from 'classnames';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import BaseModal from '../BaseModal';
import { WRAPPER } from '../../styles/navModal';
















/**
 * A NavModal component that contains cancel, save and close buttons
 *
 * @param {NavModalProps} props
 *
 * @return {React.Element}
 */
const NavModal = ({
  visible,
  onClose,
  children,
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  primaryText,
  secondaryText,
  className,
  hideIcon,
  alignActionBtnsToEnd
}) =>
<BaseModal
  visible={visible}
  onClose={onClose}
  styles={WRAPPER}>

    <div className={cx('modal__wrapper', className)}>
      <ModalHeader
      title={title}
      hideIcon={hideIcon}
      subtitle={subtitle} />

      {children}
      <ModalFooter
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      primaryText={primaryText}
      secondaryText={secondaryText}
      alignActionBtnsToEnd={alignActionBtnsToEnd} />

    </div>
  </BaseModal>;


export default NavModal;